import React from 'react';
import { renameSavedWorkflow, saveWorkflowSnapshot } from './workflowStorage';

export function SaveWorkflowModal({
  showSaveModal,
  setShowSaveModal,
  editingWorkflowId,
  setEditingWorkflowId,
  saveName,
  setSaveName,
  saveDate,
  setSaveDate,
  setWorkflowTitle,
  steps
}) {
  if (!showSaveModal) return null;

  const handleSave = () => {
    const timestamp = saveDate ? new Date(saveDate + 'T00:00:00').toISOString() : new Date().toISOString();
    if (editingWorkflowId) {
      renameSavedWorkflow(editingWorkflowId, saveName.trim(), timestamp);
    } else {
      saveWorkflowSnapshot(saveName.trim(), steps, timestamp);
    }
    setWorkflowTitle(saveName.trim());
    setShowSaveModal(false);
    setEditingWorkflowId(null);
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.4)',
        backdropFilter: 'blur(4px)'
      }}
      onClick={() => {
        setShowSaveModal(false);
        setEditingWorkflowId(null);
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '24px',
          width: '380px',
          maxWidth: '90vw',
          boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
        }}
      >
        <h3 style={{ margin: '0 0 16px', fontSize: '16px', fontWeight: 600, color: '#111827' }}>
          {editingWorkflowId ? 'Rename Workflow' : 'Save Workflow Snapshot'}
        </h3>
        <input
          autoFocus
          type="text"
          value={saveName}
          onChange={(e) => setSaveName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && saveName.trim()) {
              handleSave();
            }
          }}
          placeholder="Workflow name..."
          style={{
            width: '100%',
            boxSizing: 'border-box',
            padding: '10px 12px',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            fontSize: '14px',
            outline: 'none'
          }}
          onFocus={(e) => (e.target.style.borderColor = '#3b82f6')}
          onBlur={(e) => (e.target.style.borderColor = '#e5e7eb')}
        />
        <div style={{ marginTop: '12px' }}>
          <label style={{ fontSize: '13px', fontWeight: 500, color: '#374151', marginBottom: '6px', display: 'block' }}>
            Date
          </label>
          <input
            type="date"
            value={saveDate}
            onChange={(e) => setSaveDate(e.target.value)}
            style={{
              width: '100%',
              boxSizing: 'border-box',
              padding: '10px 12px',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              fontSize: '14px',
              outline: 'none',
              fontFamily: 'inherit',
              color: '#374151'
            }}
            onFocus={(e) => (e.target.style.borderColor = '#3b82f6')}
            onBlur={(e) => (e.target.style.borderColor = '#e5e7eb')}
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}>
          <button
            onClick={() => {
              setShowSaveModal(false);
              setEditingWorkflowId(null);
            }}
            style={{
              padding: '8px 16px',
              background: '#fff',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              fontSize: '13px',
              fontWeight: 500,
              color: '#6b7280',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
          <button
            disabled={!saveName.trim()}
            onClick={handleSave}
            style={{
              padding: '8px 16px',
              background: saveName.trim() ? '#0d9488' : '#d1d5db',
              border: 'none',
              borderRadius: '8px',
              fontSize: '13px',
              fontWeight: 500,
              color: saveName.trim() ? '#fff' : '#9ca3af',
              cursor: saveName.trim() ? 'pointer' : 'default'
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
